const info = [
    {
        name: "Vanilla JS",
        description: "Todo list",
        link: "https://js-dom-seven.vercel.app/",
        img: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1744&q=80"
    },
    {
        name: "Vanilla JS + Local Storage",
        description: "saving products without duplicates, get data from local storage, delete product by ID",
        link: "https://vanilla-js-local-storage.vercel.app/",
        img: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    },
    {
        name: "Vanilla JS + Data from file",
        description: "Countries info, filter by continent",
        link: "https://js-dom-countries-filter.vercel.app/",
        img: "https://images.unsplash.com/photo-1604549944235-3e5579b15cc2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1471&q=80"
    },
    {
        name: "React Firebase",
        description: "Contact Form",
        link: "https://contact-form-ecru.vercel.app/",
        img: "https://images.unsplash.com/photo-1589987607627-616cac5c2c5a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80"
    },
    // {
    //     name: "MERN",
    //     description: "GoalSetter",
    //     link: "https://jolitos.herokuapp.com",
    //     img: "https://images.unsplash.com/photo-1586281380923-93c9b0a7296e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80"
    // },
    {
        name: "React Redux Firebase Stripe",
        description: "Amazon Clone",
        link: "https://clone-6ee52.web.app/",
        img: "https://images.unsplash.com/photo-1557821552-17105176677c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80"
    },
    {
        name: "React API",
        description: "Countries API",
        link: "https://country-api-v3-izwqkrz6t-spuke.vercel.app/",
        img: "https://images.unsplash.com/photo-1501514799070-290ae1c889fe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
    },
    {
        name: "Students Portfolio",
        description: "Each student has a talent",
        link: "https://jkunciene.wixsite.com/suzukimokinio",
        img: "https://images.unsplash.com/photo-1455849318743-b2233052fcff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80"
    },
    {
        name: "Vanilla JS + Firebase",
        description: "Database CRUD",
        link: "https://vanilla-js-firebase.vercel.app/",
        img: "https://images.unsplash.com/photo-1519162721257-18cd195350c2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    }
]

export default info;